import React from 'react'
import cn from 'classnames'

export const Main = (props) =>
	<div>
		<div className="main page">
			<div className="grid-container" style={{width:'100%'}}>
				<div className="grid-x grid-margin-x align-center">
					{props.children}
				</div>
			</div>
		</div>
	</div>

export const MainFull = (props) =>
	<div>
		<div className="main page">
			<div className="grid-container fluid" style={{width:'100%'}}>
				<div className="grid-x grid-margin-x align-center">
					{props.children}
				</div>
			</div>
		</div>
	</div>

export const MainSlide = (props) => {
	const mainClass = cn('main slide', {center: props.center})
	return (
		<div className={mainClass}>
			<div className="grid-container fluid" style={{width:'100%'}}>
				<div className="grid-x grid-margin-x align-center" style={{width:'100%'}}>
					{props.children}
				</div>
			</div>
		</div>
)}

export const Left = (props) =>
	<div className="cell medium-6 large-7 xxlarge-5">
		{props.children}
	</div>

export const Right = (props) =>
	<div className="cell medium-6 large-5 xxlarge-4">
		{props.children}
	</div>

export const Full = (props) =>
	<div className="cell large-8 xxlarge-6">
		{props.children}
	</div>


// WEBPACK FOOTER //
// ./src/components/Content.js